import * as R from 'ramda';
// import ngAnimate from 'angular-animate';

export default function FolderController(
  $animate,
  alerts,
  docDataService,
  loaderService
) {
  const vm = this;
  // const isExpanded = false;
  vm.showChildFolder = false;
  vm.allowDeleteFolder = false;
  vm.allowAddEditFolder = false;
  vm.attachedIds = vm.attachedIds || [];
  vm.customerId = 0;
  vm.isRootFolder = (vm.folder.parentFolderId === -1);

  vm.handleExpandClick = _handleExpandClick;
  vm.handleAttachmentSelectionChange = _handleAttachmentSelectionChange;
  vm.handleDocumentMove = _handleDocumentMove;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    /* _calculateChildCount(vm.folder); */
    // _collapseChildFolders();
    // _initAttachedDocuments();

    vm.allowDeleteFolder = vm.folder.deletable && vm.canDeleteFolder;
    vm.allowAddEditFolder = vm.folder.deletable && vm.canAddFolder;
  }

  function _calculateChildCount(folder) {
    if (folder.folders || folder.documents) {
      folder.childrenCount = folder.folders.length + folder.documents.length;
    } else {
      folder.childrenCount = 0;
    }
  }

  // function _collapseChildFolders() {
  //   if (vm.folder.folders) {
  //     R.forEach(
  //       (folder) => {
  //         if (folder.hasAttachment) {
  //           folder.isExpanded = true;
  //         } else {
  //           folder.isExpanded = false;
  //         }
  //       },
  //       vm.folder.folders
  //     );
  //   }
  // }

  // function _initAttachedDocuments() {
  //   if (vm.attachedIds.length > 0) {
  //     R.forEach(
  //       (document) => {
  //         for (let i = 0; i < vm.attachedIds.length; i += 1) {
  //           if (vm.attachedIds[i] === document.documentId) {
  //             document.isAttached = true;
  //             vm.folder.isExpanded = true;
  //             vm.folder.hasAttachment = true;
  //           }
  //         }
  //       },
  //       vm.folder.documents
  //     );
  //   }
  // }

  function _handleExpandClick($event, folder) {
    if (!folder.isExpanded) {
      if (folder.childrenCount > 0) {
        loaderService.showViewLoader = true;
        vm.folder.folders = null;
        vm.folder.documents = null;
        vm.showChildFolder = false;
        $animate.enabled(false);
        docDataService.getItemList(vm.serviceId, vm.folder.folderId, vm.attachmentTypeId, vm.attachmentEntityId)
          .then((res) => {
            vm.folder.folders = res.data.result[0].folders;
            vm.folder.documents = res.data.result[0].documents;
            folder.isExpanded = !folder.isExpanded;
            vm.showChildFolder = true;
            loaderService.showViewLoader = false;
            $animate.enabled(true);
          });
      }
    } else {
      folder.isExpanded = !folder.isExpanded;
    }
  }

  function _handleAttachmentSelectionChange(document) {
    if (document.isAttached) {
      if (vm.maxAttachments && vm.attachedIds.length > vm.maxAttachments - 1) {
        alerts.error('You\'ve reached the maximum number of allowed attachments.');
        document.isAttached = false;
      } else {
        _setFolderAttachments(vm.folder);
        vm.attachedIds.push(document.documentId);
      }
    } else {
      vm.attachedIds = R.reject(
        R.equals(document.documentId),
        vm.attachedIds,
      );
    }
  }

  function _setFolderAttachments(folder) {
    console.log(folder);
  }

  function _handleDocumentMove($index, folder) {
    folder.documents.splice($index, 1);
    _calculateChildCount(folder);
  }
}

FolderController.$inject = [
  '$animate',
  'alerts',
  'docDataService',
  'loaderService',
];
